module.exports = __webpack_public_path__ + "img/pdfThumb.1e88548b.svg";